import React from 'react'

import actions from 'actions'
import Immutable from 'immutable'
import { connect } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import { basketIsShowDetailsViewFirstChange } from 'actions/basket'
import { boxSummaryVisibilityChange, trackingUnavailableRecipeList } from 'actions/boxSummary'
import { useNumPortions } from 'hooks/basket/useNumPortions'
import { useMaxRecipesForPortion } from 'hooks/menu-boxes/useMaxRecipesForPortion'
import { useMinRecipesForPortion } from 'hooks/menu-boxes/useMinRecipesForPortion'
import { useIsRightSizingExperimentEnabled } from 'hooks/useIsRightSizingExperimentEnabled'
import { usePricing } from 'routes/Menu/domains/pricing'
import { getOkRecipeIds, getUnavailableRecipeIds } from 'routes/Menu/selectors/basket'
import { getBasketRecipes, getBasketSlotId } from 'selectors/basket'
import { getDiscountPercentFromPromoStoreEntry } from 'selectors/promoStoreSelectors'

import { checkoutBasket } from '../../../actions/menuCheckoutClick'
import { menuRecipeDetailVisibilityChange } from '../../../actions/menuRecipeDetails'
import { useBasket } from '../../../domains/basket'
import { Details } from './Details'

const mapStateToProps = (state) => ({
  accessToken: state.auth.get('accessToken'),
  deliveryDays: state.boxSummaryDeliveryDays,
  menuBoxPrices: state.menuBoxPrices,
  promoCode: state.basket.get('promoCode'),
  recipes: state.recipesV3.recipes,
  coreIdToUUIDMap: state.recipesV3.coreIdToUUID,
  basketRecipes: getBasketRecipes(state),
  okRecipeIds: getOkRecipeIds(state),
  slotId: getBasketSlotId(state),
  menuFetchPending: state.pending.get(actionTypes.MENU_FETCH_DATA),
  orderSaveError: state.error.get(actionTypes.ORDER_SAVE),
  unavailableRecipeIds: getUnavailableRecipeIds(state),
  isTestUser: state.user.get('isTestUser'),
  discountPercentageFromStore: getDiscountPercentFromPromoStoreEntry(
    state,
    state.basket.get('promoCode'),
  ),
  isAuthenticated: state.auth.get('isAuthenticated'),
})

const DetailsPure = (props) => {
  const { isPending, pricing } = usePricing()
  const { numPortions } = useNumPortions()
  const minRecipesNum = useMinRecipesForPortion(numPortions)
  const maxRecipesNum = useMaxRecipesForPortion(numPortions)
  const { removeRecipe } = useBasket()
  const isRightSizingExperimentEnabled = useIsRightSizingExperimentEnabled()
  let displayOptions = Immutable.List([])

  if (isRightSizingExperimentEnabled) {
    displayOptions = Immutable.List([
      'alternateOrderTotal',
      'alignDateHeaderItemsSpaceBetween',
      'headingUseSentenceCase',
      'hidePricePerServingMessage',
      'hideRecipeTitleArrow',
      'hideRecipesWhenNoSelections',
      'leftAlignHeading',
      'reverseHeaderComponentsOrder',
      'squareRecipeImages',
    ])
  }

  const updatedProps = {
    ...props,
    displayOptions,
  }

  return (
    <Details
      {...updatedProps} // eslint-disable-line react/jsx-props-no-spreading
      pricingPending={isPending}
      prices={pricing}
      maxRecipesNum={maxRecipesNum}
      minRecipesNum={minRecipesNum}
      removeRecipeFromBasket={removeRecipe}
    />
  )
}

const DetailsContainer = connect(mapStateToProps, {
  clearSlot: actions.basketSlotClear,
  basketRestorePreviousDate: actions.basketRestorePreviousDate,
  showRecipeDetailsOnClick: menuRecipeDetailVisibilityChange,
  boxSummaryVisibilityChange,
  trackingUnavailableRecipeList,
  checkoutBasket,
  basketIsShowDetailsViewFirstChange,
})(DetailsPure)

export { DetailsContainer }
